import React from 'react';
import { LeftPanelPageBaseLeftComponentItemStyle as S } from './LeftPanelPageBaseComponentItem.style';
import { Icon } from 'components/Icon/Icon';

export const LeftPanelPageBaseLeftComponentItem: React.FC<{ title: string; description: string }> = ({
  title,
  description,
}) => {
  return (
    <S.Container>
      <S.IconBox>
        <Icon icon="checkCircleSolid" size={24} color="pink300" />
      </S.IconBox>
      <S.Content>
        <S.Title>{title}</S.Title>
        <S.Description>{description}</S.Description>
      </S.Content>
    </S.Container>
  );
};
